import { TEAM_TYPES } from "./types";

const teamsTypes = {
  [TEAM_TYPES.COLLEGES]: "college",
  [TEAM_TYPES.HIGH_SCHOOLS]: "high school"
};

const metaData = {
  description:
    "Rivals Teams List For College And Highschool Football And Basketball",
  title: "rivals [sport] [type] teams"
};

export default {
  differentTypeLink: "view [type] teams sites",
  mapTeamTypeToString: (type: TEAM_TYPES): string => teamsTypes[type],
  metaData,
  teamsTypes,
  title: "team sites"
};
